<nz-form-item>
    <nz-form-label [nzFor]="fieldId" [nzRequired]="isRequired" [nzSm]="8" [nzXs]="24">{{ fieldLabel }}</nz-form-label>
    <nz-form-control
        [nzSm]="16"
        [nzXs]="24"
        [nzErrorTip]="fieldErrorTip"
        [nzValidateStatus]="!formChanged && (hasError || hasRequiredError) ? 'error' : 'success'"
    >
        <nz-input-group [nzSuffix]="suffixActions">
            <input
                type="text"
                nz-input
                [id]="fieldId"
                disabled
                [ngModelOptions]="{ standalone: true }"
                [ngModel]="viewModel"
                [placeholder]="fieldLabel"
            />
            <ng-template #fieldErrorTip let-control>
                @if (hasError) {
                    <span>Kāds no objekta laukiem ir kļūdains</span>
                }
                @if (hasRequiredError) {
                    <span>Jānorāda obligāti</span>
                }
            </ng-template>
        </nz-input-group>
    </nz-form-control>
    <ng-template #suffixActions>
        @if (!isEditMode || (isEditMode && !object)) {
            <button nz-button [nzSize]="'small'" [nzType]="'primary'" (click)="addObject()">
                <i nz-icon nzType="plus" nzTheme="outline"></i>
            </button>
        }
        @if (object && canEdit) {
            <button nz-button [nzType]="'secondary'" [nzSize]="'small'" (click)="editObject()">
                <i nz-icon nzType="edit" nzTheme="outline"></i>
            </button>
        }
    </ng-template>
</nz-form-item>
